<h2>User Administration</h2>
<div fxLayout="row" style="padding: 20px 10px 20px 10px;">
    <div class="center-vertical" fxFlex="20%">
        <p>Total: {{this.showedRows.length}}</p>
    </div>
    <div class="center-vertical" fxFlex="40%" fxLayoutAlign="center center">
        <button type="button" class="button-secondary-small" (click)="settingUser()"  style="white-space: nowrap; align-items: center; display: flex; margin-right: 3px;">
            <mat-icon fontIcon="settings" style="color: gray; cursor: pointer; margin-right: 5px; font-size: 20px; width: fit-content; height: fit-content;"></mat-icon>
            <div>Create New User</div>
        </button>
    </div>
    <div class="class-mat-field" fxFlex="25%"  fxLayoutAlign="center center">
        <button class="button-validate-small" (click) = "loadUserData()">Refresh</button>
    </div>

    <div class="center-vertical" fxFlex="40%" style="display: flex; align-items: center;">
        <div style="margin-left: auto;">
            <input class="col-input"  (keyup)="applyFilterLocal($event.target, 'all_column')" placeholder="Search">
        </div>
    </div>
</div>
<div class="table_div" style="height: calc(100% - 100px);">
    <div class="nav-preview" fxLayout="row" fxLayoutAlign="center center" style="float: bottom; position: absolute;">
        <mat-icon [ngClass]="navIndex === 0 ? 'nav-inactive' : 'nav-active'"style="padding: 0px 14px 0px 0px; font-size: 40px; height: 40px;" fontIcon="arrow_left" title="Previous" (click)="movePrevNextNavigation('prev')"></mat-icon>
        <span style="font-weight: bold;"> Nav {{ navIndex *  this.navData.limit}} / {{ totalRows}}</span>
        <mat-icon [ngClass]="navIndex === totalNavigations - 1 ? 'nav-inactive' : 'nav-active'" style="padding-right: 10px; font-size: 40px; height: 40px;" fontIcon="arrow_right" title="Next" (click)="movePrevNextNavigation('next')"></mat-icon>
    </div>
    <table>
        <thead>
            <tr>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id', 'number')"></mat-icon>
                    <div class="column-name">Id</div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_user', 'number')"></mat-icon>
                    <div class="column-name">Id User</div>
                    <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_user')">
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'first_name', 'string')"></mat-icon>
                    <div class="column-name">First Name</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'first_name')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'last_name', 'string')"></mat-icon>
                    <div class="column-name">Last Name</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'last_name')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'email', 'string')"></mat-icon>
                    <div class="column-name">Email</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'email')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'phone', 'string')"></mat-icon>
                    <div class="column-name">Phone</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'phone')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'country_name', 'string')"></mat-icon>
                    <div class="column-name">Country</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'country_name')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'function_name', 'string')"></mat-icon>
                    <div class="column-name">Function</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'function_name')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'promo_code', 'string')"></mat-icon>
                    <div class="column-name">Promo Code</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'promo_code')"></div>
                </th>
                
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'last_active_date', 'date')"></mat-icon>
                    <div class="column-name">Active Date</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'last_active_date')"></div>
                </th>
                <th></th>
            </tr>
        </thead>
        <tbody #row_tbody *ngFor="let row of showedRows; let i = index">
            <tr (click)="toggleRow(row, $event.target, row_tbody)">
                <td>{{ row['id'] }}</td>
                <td>{{ row['id_user'] }}</td>
                <td matTooltip="{{ row['first_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['first_name'] }}</td>
                <td matTooltip="{{ row['last_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['last_name'] }}</td>
                <td matTooltip="{{ row['email'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['email'] }}</td>
                <td>{{ row['phone'] }}</td>
                <td>{{ row['country_name'] }}</td>
                <td matTooltip="{{ row['function_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['function_name'] }}</td>
                <td>{{ row['promo_code'] }}</td>
                <td>{{ row['last_active_date'] }}</td>
            </tr>
            <tr class="expand_detail" *ngIf="row['expanded']">
                <td colspan="10">
                    <app-setting-user [action]="'update_user'" [rowInfos]="row" [userInfos]="userInfos" [countryData]="countryData" [functionData]="functionData"></app-setting-user>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="showedRows.length === 0">
            <tr ><td colspan="9" style="text-align: center;">No matching records found</td></tr>
        </tbody>
    </table>
</div>